// Styles globaux du design system — **une seule fois**, ici, au point d'entrée de l'app
// (cf. `packages/ui/CLAUDE.md`). Ils embarquent tokens + densité + reset ; un composant
// de `@ghp/ui` ne les importe jamais lui-même.
import '@ghp/ui/styles'

import { createApiClient, readApiBaseUrl } from '@ghp/api-client'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { ToastProvider } from '@ghp/ui'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createQueryClient } from './app/query-client'
import { createAppRouter } from './app/router'
import { startErrorReporting } from './app/error-reporting'

// Avant tout le reste : une erreur au montage est la première qu'on veut voir (D15).
startErrorReporting(import.meta.env)

// L'URL est substituée à la compilation : un bundle construit sans elle refuse de démarrer
// plutôt que d'appeler le poste de l'utilisateur (D23).
const api = createApiClient({ baseUrl: readApiBaseUrl(import.meta.env) })
const queryClient = createQueryClient()
const router = createAppRouter(queryClient, api)

const container = document.getElementById('root')

if (!container) {
  // Échec bruyant plutôt qu'une page blanche : ce cas ne peut venir que d'un `index.html`
  // désynchronisé de ce point d'entrée.
  throw new Error('Montage impossible : aucun élément #root dans index.html.')
}

createRoot(container).render(
  <StrictMode>
    {/*
      Le `QueryClientProvider` enveloppe le routeur : les `loader` de routes accèdent au
      client par le contexte du routeur, les composants par ce provider — les deux
      pointent sur la même instance.
    */}
    <QueryClientProvider client={queryClient}>
      {/* Les confirmations du prototype (« Contrôle archivé »…) : une seule pile pour tous les écrans. */}
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
)
